// src/data/portfolioImages.js
export const portfolioImages = [
    // Equine Photography
    {
      id: 1,
      src: "/images/portfolio/equine/photo2.jpg",
      category: "equine",
      title: "Arabian Beauty",
      description: "Capturing the grace and power of these magnificent creatures"
    },
    {
      id: 2,
      src: "/images/portfolio/equine/photo7.jpg",
      category: "equine",
      title: "Golden Hour Ride",
      description: "The perfect bond between horse and rider"
    },
    {
      id: 3,
      src: "/images/portfolio/equine/photo9.jpg",
      category: "equine",
      title: "Morning Training",
      description: "Early morning sessions in the arena"
    },
    // Black Background Equine
    {
      id: 15,
      src: "/images/portfolio/black_background/photo2.jpg",
      category: "black-background",
      title: "Equine Portrait",
      description: "Fine-art black background portrait of an equine partner"
    },
    {
      id: 16,
      src: "/images/portfolio/black_background/photo3.jpg",
      category: "black-background",
      title: "Hemi",
      description: "Dramatic studio-style horse portrait with timeless detail"
    },
    // Couples Photography
    {
      id: 4,
      src: "/images/portfolio/couples/photo1.jpg",
      category: "couples",
      title: "Engagement Session",
      description: "Capturing love stories in beautiful settings"
    },
    {
      id: 5,
      src: "/images/portfolio/couples/photo3.jpg",
      category: "couples",
      title: "Pawrents Getting Married!",
      description: "Here's to a new life of love and happiness!"
    },
    // Wedding Photography
    {
      id: 6,
      src: "/images/portfolio/wedding/photo1.jpg",
      category: "weddings",
      title: "Wedding Day Joy",
      description: "The most important day of their lives"
    },
    {
      id: 7,
      src: "/images/portfolio/wedding/photo4.jpg",
      category: "weddings",
      title: "Equine Wedding!",
      description: "Magical moments"
    },
    // Family Photography
    {
      id: 8,
      src: "/images/portfolio/family/photo1.jpg",
      category: "family",
      title: "Family Portrait",
      description: "Creating memories that last a lifetime"
    },
    {
      id: 9,
      src: "/images/portfolio/family/photo3.jpg",
      category: "family",
      title: "Family Session",
      description: "Celebrating families!"
    },
    // Senior Photography
    {
      id: 10,
      src: "/images/portfolio/senior/photo1.jpg",
      category: "senior",
      title: "Senior Portrait",
      description: "Celebrating achievements and new beginnings"
    },
    {
      id: 11,
      src: "/images/portfolio/senior/photo4.jpg",
      category: "senior",
      title: "Graduation Day",
      description: "Marking this important milestone"
    },
    // Prom Photography
    {
      id: 12,
      src: "/images/portfolio/prom/photo2.jpg",
      category: "prom",
      title: "Prom Night Glamour",
      description: "Making prom night unforgettable"
    },
    // Pet Photography
    {
      id: 13,
      src: "/images/portfolio/pets/photo3.jpg",
      category: "pets",
      title: "Best Friend Portrait",
      description: "Capturing the personality of beloved pets"
    },
    {
      id: 14,
      src: "/images/portfolio/pets/photo2.jpg",
      category: "pets",
      title: "Saying Goodbye",
      description: "Reflecting on the love and happiness had"
    }
  ];